import {
  ERROR_AUTH,
  USER_AUTH,
  MESSAGE_AUTH,
  GET_DASHBOARD,
  SET_TOAST,
  POST_SEARCH,
} from '../actions/types';

const initialState = {
  error: null,
  message: null,
  userAuth: null,
  toast: null,
  dashboard: null,
  searchList: [],
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case POST_SEARCH:
      return { ...state, searchList: action.payload };
    case SET_TOAST:
      return { ...state, toast: action.payload };
    case GET_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case MESSAGE_AUTH:
      return { ...state, message: action.payload };
    case ERROR_AUTH:
      return { ...state, error: action.payload };
    case USER_AUTH:
      return { ...state, userAuth: action.payload };
    default:
      return { ...state };
  }
}
